/**
 * デュエル一覧の試合の行に置く「ログを1からやり直す」（Issue #467）。入力画面の中には置かない（押し間違えると全部消えるので、
 * 入力の手の届く場所から離す）。1 回目で確認を出し、「全部消す」で ocgCore の resetReplayForGame。
 */
import { useState } from 'react';
import { resetReplayForGame } from './ocgCore';

export default function ResetReplayButton({ gameUuid }) {
  const [phase, setPhase] = useState('idle');   // idle | confirm | busy | done | error
  const [message, setMessage] = useState(null);
  const run = async () => {
    setPhase('busy'); setMessage(null);
    try {
      await resetReplayForGame(gameUuid);
      setPhase('done'); setMessage('やり直しました');
    } catch (e) {
      setPhase('error'); setMessage(String(e?.message ?? e));
    }
  };
  if (phase === 'confirm' || phase === 'busy') {
    return (
      <span data-testid="reset-replay-confirm" style={{ display: 'inline-flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '0.75rem', color: '#f99' }}>操作・登録・先攻と開始位置・演出のタイミングを全部消します</span>
        <button type="button" className="btn btn-sm btn-secondary" disabled={phase === 'busy'} onClick={() => setPhase('idle')}>やめる</button>
        <button type="button" className="btn btn-sm btn-danger" data-testid="reset-replay-run" disabled={phase === 'busy'} onClick={run}>{phase === 'busy' ? '消しています…' : '全部消す'}</button>
      </span>
    );
  }
  return (
    <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
      <button type="button" className="btn btn-sm btn-secondary" data-testid="reset-replay" title="再現エンジンの入力（ログ）を全部消して、デッキを取り込み直した新しい replay にする"
        onClick={() => { setPhase('confirm'); setMessage(null); }}>ログを1からやり直す</button>
      {message ? <span role="status" style={{ fontSize: '0.75rem', color: phase === 'error' ? '#f99' : '#7c7' }}>{message}</span> : null}
    </span>
  );
}
